import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { Endpoints } from "../../const/Api";
import { RootState } from "../../store";
import { client } from "../../tool/client";
import {
  endAuto,
  finishAnimation,
  forcefinishAuto,
  resetResult,
  sendAutoBetAction,
} from "../result/reducer";
import { History, HistoryFull } from "./type";

interface InitialState {
  current_round: number;

  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null | undefined;
  data: HistoryFull[];
  last_history: History[];
  viewAll: boolean;
}

const historyAdapter = createEntityAdapter<History>({
  selectId: (history) => history.round_id,
  sortComparer: (a, b) => b.round_id - a.round_id,
});

const initialState: InitialState = {
  current_round: 1,
  status: "idle",
  error: null,
  data: [],
  last_history: [],
  viewAll: false,
};

let domain: any;

/*
 * With PLK00001 batching, NET22 (and therefore history) only moves once the
 * burst settles. Spamming send_bet used to fire /game/history on every click
 * (twice -- betbar + game). Wait until the player stops clicking for about
 * one batch idle window before hitting history once for the whole burst.
 */
const HISTORY_AFTER_SPAM_MS = 1500;
const AUTO_BET_GAP_MS = 500;

type HistoryRefreshOpts = boolean | { auto?: boolean; immediate?: boolean };

let historyTimer: ReturnType<typeof setTimeout> | undefined;
let historyWaiters: Array<{
  resolve: (value: any) => void;
  reject: (reason?: any) => void;
}> = [];

function scheduleHistoryFetch(immediate: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    historyWaiters.push({ resolve, reject });

    if (historyTimer) {
      clearTimeout(historyTimer);
      historyTimer = undefined;
    }

    const run = async () => {
      historyTimer = undefined;
      const waiters = historyWaiters;
      historyWaiters = [];

      try {
        domain = domain || (await (await fetch(Endpoints.Domain)).json());
        const response = await client.get(domain.history);

        if (!response.data.data) {
          throw new Error("data history empty");
        }

        waiters.forEach((w) => w.resolve(response));
      } catch (error) {
        waiters.forEach((w) => w.reject(error));
      }
    };

    if (immediate) {
      run();
    } else {
      historyTimer = setTimeout(run, HISTORY_AFTER_SPAM_MS);
    }
  });
}

export const fetchHistory = createAsyncThunk(
  "history/fetchHistory",
  async () => {
    const response = await new Promise((r, rj) => {
      setTimeout(async () => {
        try {

          domain = domain || await (await fetch(Endpoints.Domain)).json();

          const response = await client.get(domain.history);
          if (!response.data.data) {
            rj("data history empty");
          }
          r(response);
        } catch (error) {

        }
      }, 1000);
    });

    return (response as any).data.data;
  }
);
let i: any;
export const refreshHistory = createAsyncThunk(
  "history/refreshHistory",
  async (opts: HistoryRefreshOpts, { dispatch, getState }: any) => {
    const auto = typeof opts === "boolean" ? opts : !!opts?.auto;
    const immediate =
      typeof opts === "object" ? !!opts?.immediate : false;
    const state: any = getState();
    let v: any = 0;

    // Auto-continue must stay per-bet; only the history GET is debounced.
    if (state.result.auto) {
      // setTimeout(() => {

      if (i) {
        clearInterval(i);
        i = undefined;
      }
      i = setInterval(() => {
        v = 100 + v;
        //  console.log(v)
        if (
          getState().result.payload[getState().result.singleCount] && ( getState().auth.player.player_balance >=
          getState().result.payload[getState().result.singleCount].last_bet
            .total_amount)
        ) {
          // console.log(getState().result.singleCount, getState().result.payload[getState().result.singleCount].last_bet)
          dispatch(
            sendAutoBetAction({
              ...getState().result.payload[getState().result.singleCount]
                .last_bet,
              button_bet: {
                ...getState().result.payload[getState().result.singleCount]
                  .last_bet.button_bet,
                round_id:
                  getState().result.payload[getState().result.singleCount]
                    .last_bet.button_bet.round_id + 1,
              },
              round_id:
                getState().result.payload[getState().result.singleCount]
                  .last_bet.button_bet.round_id + 1,
            })
          );
          clearInterval(i);
          i = undefined;
        } else {
          if (getState().result.inQueue == 0 && getState().result.auto) {
            dispatch(forcefinishAuto());
            clearInterval(i);
            i = undefined;
          }
        }
      }, AUTO_BET_GAP_MS);
      // }, setting.delay);
    } else {
      // dispatch(refreshHistory(true));

    }

    // During continuous auto, only continue the next bet here. History is
    // flushed when auto stops (immediate) or when manual spam goes quiet.
    if (getState().result.auto && !immediate) {
      return {
        data: getState().history.data,
        auto,
        last_round:
          getState().result.payload[getState().result.singleCount]?.last_bet
            ?.button_bet?.round_id + 1,
      };
    }

    const response = await scheduleHistoryFetch(immediate);
    return {
      data: (response as any).data.data, auto: auto, last_round: getState().result.payload[getState().result.singleCount]
        ?.last_bet?.button_bet?.round_id + 1
    };
  }
);

export const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    addedHistory: (state, action: PayloadAction<History>) => {
      // historyAdapter.addOne(state, action.payload)
      // state.data = [...state.data, action.payload]
    },
    addedLastHistory: (state, action: PayloadAction<History>) => {
      state.last_history = [...state.last_history, action.payload];
      // historyAdapter.addOne(state, action.payload)
    },
    clearLastHistory: (state, action: PayloadAction) => {
      // historyAdapter.addOne(state, action.payload)
      state.last_history = [];
    },
    closeViewAll: (state, action: PayloadAction) => {
      state.viewAll = false;
    },
    openViewAll: (state, action: PayloadAction) => {
      state.viewAll = true;
      // state.viewAll = !state.viewAll ;
    },
    newRound: (state, action: PayloadAction) => {
      state.current_round = state.current_round + 1;
      // state.viewAll = !state.viewAll ;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchHistory.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(
        fetchHistory.fulfilled,
        (state, action: PayloadAction<HistoryFull[]>) => {
          state.status = "succeeded";

          const lastHistory = action.payload[0];
          if (lastHistory) {
            state.current_round = lastHistory.round_id + 1;
          }

          state.data = action.payload;
        }
      )
      .addCase(fetchHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(
        refreshHistory.fulfilled,
        (state, action: PayloadAction<{ data: HistoryFull[], auto: boolean, last_round: number }>) => {
          state.status = "succeeded";

          const lastHistory = action.payload.data[0];

        
          

          if (action.payload.auto) {
            if (state.current_round < action.payload.last_round) {
              state.current_round = action.payload.last_round;
            } 


            
          }
          if (lastHistory) {
            // state.current_round = lastHistory.round_id + 1;
            if(!action.payload.auto && (state.current_round < lastHistory.round_id + 1)) {
              state.current_round = lastHistory.round_id + 1;
  
            }
  
            if(!action.payload.auto && (state.current_round > lastHistory.round_id + 1)) {
              state.current_round = lastHistory.round_id + 1;
            }
          }

          state.data = action.payload.data;
        }
      );
  },
});

export const {
  addedHistory,
  clearLastHistory,
  addedLastHistory,
  openViewAll,
  newRound,
  closeViewAll,
} = historySlice.actions;

export default historySlice.reducer;
